var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-delivery-info" }, [
    _vm.delivery.shippingInfo
      ? _c(
          "a",
          {
            staticClass: "text--underline shipping-info",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.showFormRegister()
              }
            }
          },
          [_vm._v(_vm._s(_vm.delivery.shippingInfoSlice))]
        )
      : _vm.delivery.isCompleteRegisterEnable
      ? _c(
          "button",
          {
            staticClass:
              "btn btn-primary btn-shipping-complete-register shipping-info",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.showFormRegister()
              }
            }
          },
          [_vm._v("発送完了登録")]
        )
      : _c(
          "button",
          {
            staticClass:
              "btn btn-basic btn-shipping-complete-register shipping-info",
            attrs: { type: "button", disabled: "true" }
          },
          [_vm._v("発送完了登録")]
        ),
    _vm._v(" "),
    _vm.showForm
      ? _c(
          "div",
          {
            class:
              "box-form-delivery-info delivery-info-" + _vm.delivery.deliveryNo,
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("strong", [
              _vm._v(
                "「追跡番号が記載されたURL」もしくは「配送事業者名と追跡番号」を入力してください。"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box-info-input" }, [
              _c("div", [_vm._v(_vm._s(_vm.exampleRegisterText))]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.shippingInfoInput,
                    expression: "shippingInfoInput",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control delivery-info",
                attrs: { name: "delivery-info", rows: "3" },
                domProps: { value: _vm.shippingInfoInput },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.shippingInfoInput = $event.target.value.trim()
                  },
                  blur: function($event) {
                    _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary m-t-sm",
                  attrs: { type: "button", disabled: !_vm.shippingInfoInput },
                  on: {
                    click: function($event) {
                      _vm.deliveryInfoRegister()
                    }
                  }
                },
                [_vm._v("登録する")]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c5b6194", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5b6194","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/components/DeliveryRegisterInfoBubble.vue
// module id = null
// module chunks = 